import {
  FETCH_IMPORT_HISTORY_STATUS_SUCCESS,
  FETCH_IMPORT_HISTORY_SUCCESS,
  FETCHING_IMPORT_HISTORY_SUCCESS
} from './ImportHistoryConstants';
import axios from 'axios';
import { downloadFile } from 'redux/files/FilesActions';

const fetchImportHistorySuccess = (importHistoryData, pageState) => ({ type: FETCH_IMPORT_HISTORY_SUCCESS, importHistoryData, pageState });
const fetchingImportHistory = pageStats => ({ type: FETCHING_IMPORT_HISTORY_SUCCESS, pageStats });
const fetchImportHistoryStatusSuccess = importHistoryStatusData => ({ type: FETCH_IMPORT_HISTORY_STATUS_SUCCESS, importHistoryStatusData });

const url = 'utm/v1/import/history';

export const fetchImportHistory = (page, perPage, recursiveCount = 0) => dispatch => {
  dispatch(fetchingImportHistory({ page, perPage }));
  axios.get(`${ url }?page=${ page }&perPage=${ perPage }`)
    .then(importHistoryResult => {
      const { items, pageState } = importHistoryResult.data.data;
      if (items.find(item => item.importStatusHistory === 'Processing')) {
        if(recursiveCount < 3) {
          setTimeout(() => dispatch(fetchImportHistory(page, perPage, recursiveCount + 1)), 5000);
        }
      }
      dispatch(fetchImportHistorySuccess(items, pageState));
    })
    .catch(error => {
      throw error;
    });
};

export const fetchImportHistoryStatuses = () => dispatch => {
  axios.get(`${ url }/status`)
    .then(importHistoryStatusResult => {
      dispatch(fetchImportHistoryStatusSuccess(importHistoryStatusResult.data.data.items));
    })
    .catch(error => {
      throw error;
    });
};

export const getImportFile = file => dispatch =>
  downloadFile({
    file,
    url: `v1/s1/assets/${file.id}`
  })(dispatch);


// WEBPACK FOOTER //
// ./src/redux/importHistory/ImportHistoryActions.js